import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
} from "react-native";
import Ionicon from "react-native-vector-icons/Ionicons";
import Colors from "@microdoing/shared/constants/Colors";
import * as Progress from "react-native-progress";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");
const aspectRatio = height / width;
const isPad = () => aspectRatio < 1.6;

const SignupHeader = ({ progress, title, onPressExit = null }) => {
  return (
    <View>
      <TouchableOpacity
        testID="exit-button"
        hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
        style={styles.settings}
        onPress={onPressExit}
      >
        <Ionicon
          name="close-circle-outline"
          size={25}
          color={theme.colors["neutral.400"]}
        />
      </TouchableOpacity>
      <Text style={styles.title}>{i18n.t(title)}</Text>
      <Progress.Bar
        progress={progress}
        width={width}
        height={8}
        borderWidth={0}
        unfilledColor={theme.colors["neutral.100"]}
        color={Colors.green}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    marginTop: isPad() ? 2 : 10,
    textAlign: "center",
    marginBottom: isPad() ? 5 : 15,
    fontSize: isPad() ? wp("4%") : wp("6%"),
    fontWeight: "bold",
    color: theme.colors["neutral.900"],
  },
  settings: {
    position: "absolute",
    zIndex: 10,
    right: 15,
    top: 5,
  },
});

SignupHeader.defaultProps = {
  title: i18n.t("signup-header"),
  progress: 0.1,
};

export default SignupHeader;
